<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHero image="seafood-homepage-hero.jpg">
      <TextHeading variant="subtitle">70 species of seafood, responsibly sourced</TextHeading>
      <TextHeading variant="xl">
        Sold at Morrisons by over
        <br>1,000 fully trained in-store
        <br>fishmongers
      </TextHeading>
      <BaseButton class="mt-10 text-primary" rounded="full" variant="white" width="small">
        <BaseIcon name="arrow_downward" size="22"></BaseIcon>
      </BaseButton>
    </PageHero>
    <PageGrid>
      <PageMain>
        <PageSection
          title="We are proud of all fresh fish and seafood sold in our stores and cafés"
        >
          <Cards cols="4">
            <CardsCol>
              <CardLink title="Responsible sourcing" link="See our approach" category="Sustainable"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink title="Farmed seafood" link="See our approach" category="Sustainable"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink title="Wild capture" link="See our approach" category="Sustainable"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink title="Health & Nutrition" link="See our approach" category="Sustainable"></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageHighlightArticles subtitle="Our approach" title="Seafood sourcing" tabImages filter></PageHighlightArticles>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>
<script>
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import BaseButton from '../elements/BaseButton.vue'
import PageGrid from '../elements/PageGrid.vue'
import PageHero from '../components/PageHero.vue'
import CardLink from '../components/CardLink.vue'
import TheFooter from '../components/TheFooter.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import TextHeading from '../elements/TextHeading.vue'
import TheHeader from '../components/TheHeader.vue'
import Cards from '../elements/Cards.vue'
import CardsCol from '../elements/CardsCol.vue'
import PageHighlightArticles from '../components/PageHighlightArticles.vue'
export default {
  name: 'SeafoodHomepage',
  components: {
    BreadcrumbBar,
    TheHeader,
    TextHeading,
    PageMain,
    PageSection,
    TheFooter,
    CardLink,
    PageHero,
    PageGrid,
    BaseButton,
    CardsCol,
    Cards,
    PageHighlightArticles
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>